import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonService } from '../shared/common/common.service';
import { LoginComponent } from './login/login.component';
import { CoreModule } from '../core/core.module';
import { RolesService } from './roles/roles.service';
import { UserService } from './users/user.service';
import { LoggedOutComponent } from './logged-out/logged-out.component';
import { InternalLoginComponent } from './internal-login/internal-login.component';
import { UsersComponent } from './users/users.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { UserEditComponent } from './users/user-edit/user-edit.component';
import { UserListComponent } from './users/user-list/user-list.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoginShowAppVersionComponent } from './login-show-app-version/login-show-app-version.component';
import { TextMaskModule } from 'angular2-text-mask';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { RequestPasswordResetComponent } from './forgot-password/request-password-reset/request-password-reset.component';
import { ResetPasswordComponent } from './forgot-password/reset-password/reset-password.component';
import { ForgotPasswordService } from './forgot-password/forgot-password.service';
import { ResetEmailSentComponent } from './forgot-password/reset-email-sent/reset-email-sent.component';

@NgModule({
  imports: [
    CommonModule,
    AuthRoutingModule,
    FormsModule,
    NgSelectModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    CoreModule,
    TextMaskModule,
    NgbModule.forRoot(),
  ],
  declarations: [
    InternalLoginComponent,
    LoggedOutComponent,
    LoginComponent,
    UsersComponent,
    UserListComponent,
    UserEditComponent,
    LoginShowAppVersionComponent,
    ForgotPasswordComponent,
    RequestPasswordResetComponent,
    ResetPasswordComponent,
    ResetEmailSentComponent
  ],
  providers: [
    CommonService,
    RolesService,
    UserService,
    ForgotPasswordService
  ],
  exports: [
    UsersComponent,
    UserListComponent,
    UserEditComponent
  ]

})
export class AuthModule { }



// WEBPACK FOOTER //
// ./src/app/auth/auth.module.ts